import React from "react";
import { motion } from "framer-motion";
import { MountainIcon, GemIcon, LeafIcon, HeartIcon, BoxIcon } from "lucide-react";
interface Pillar {
  icon: BoxIcon;
  title: string;
  description: string;
}
const PILLARS: Pillar[] = [{
  icon: MountainIcon,
  title: 'Tranquilidad',
  description: 'Lejos del ruido, cerca de lo que importa. El silencio del Tolima como melodía de fondo.'
}, {
  icon: GemIcon,
  title: 'Lujo Natural',
  description: 'Piscina privada, sauna, cócteles y restaurante. Todo lo premium, nada de artificial.'
}, {
  icon: LeafIcon,
  title: 'Naturaleza',
  description: 'Vegetación densa, montañas imponentes y un verde que sana desde adentro.'
}, {
  icon: HeartIcon,
  title: 'Descanso Real',
  description: 'Despierta en otro mundo. Desayuno con selva al fondo y el tiempo para ti.'
}];
export function ExperienceSection() {
  return <section className="bg-cream px-6 sm:px-8 lg:px-12 py-24" data-id="element-130" data-mp="1tx1rmyd6mb4f">
      <div className="max-w-6xl mx-auto" data-id="element-131" data-mp="1yqmsqza2nl7u">
        <motion.div initial={{
        opacity: 0,
        y: 35
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-132" data-mp="1yro65aek8jsq">
          <span className="inline-block text-[0.67rem] font-semibold tracking-[0.3em] uppercase text-forest-500 mb-5" data-id="element-133" data-mp="2p1fw3y3ha7iu">
            La Experiencia
          </span>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.15] text-night" data-id="element-134" data-mp="2yxj7luk7ziig">
            No es solo glamping.
            <br data-id="element-135" data-mp="2tyy49m9o8ips" />
            <em className="italic text-forest-500" data-id="element-136" data-mp="2u1kho2j8tsfx">Es un estado del alma.</em>
          </h2>
          <p className="text-sm leading-[1.8] text-black/50 max-w-xl mx-auto mt-4" data-id="element-137" data-mp="37wmtf6aruc0n">
            En Refugio Caracolí cada detalle fue pensado para que sientas algo real. La brisa de la montaña, el
            sonido del agua, el lujo de no tener afán.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-138" data-mp="18nptkvs0brbb">
          {PILLARS.map((pillar, i) => {
          const Icon = pillar.icon;
          return <motion.div key={pillar.title} initial={{
            opacity: 0,
            y: 35
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.8,
            delay: i * 0.1
          }} className="group relative text-center px-7 py-10 bg-white rounded-3xl overflow-hidden transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_20px_60px_rgba(0,0,0,0.12)]" data-id="element-139" data-mp="3doabuppl9wad" data-mpi={i}>
                <div className="absolute bottom-0 left-0 right-0 h-[3px] bg-gradient-to-r from-forest-500 to-gold scale-x-0 group-hover:scale-x-100 transition-transform duration-500" data-id="element-140" data-mp="57xmdjnl56rf" />
                <div className="w-[58px] h-[58px] mx-auto mb-5 bg-gradient-to-br from-forest-900 to-forest-700 rounded-full flex items-center justify-center" data-id="element-141" data-mp="e9f04vdiswcy">
                  <Icon className="w-6 h-6 text-gold" strokeWidth={1.5} data-id="element-142" data-mp="23ozhot4du8em" />
                </div>
                <h3 className="font-display text-2xl font-normal text-night mb-2" data-id="element-143" data-mp="1yq4r3506bfjy">{pillar.title}</h3>
                <p className="text-[0.83rem] text-black/50 leading-[1.7]" data-id="element-144" data-mp="1uo9o7w2lgu42">{pillar.description}</p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}